<template>
  <div title="Submit a Project" @click="createEntry" class="add-entry card">
    <img
      src="https://firebasestorage.googleapis.com/v0/b/cap-prize.appspot.com/o/interface%2Fcreate_entry.svg?alt=media&token=99d806ec-ee98-4c1a-8c30-249f37c5c624"
    >
    <div class="card-body">
      <b-button variant="primary">Create an Entry</b-button>
    </div>
    <!--.card-text -->
  </div>
  <!--.card -->
</template>

<script>
export default {
  name: 'create-entry-card',
  data() {
    return {
      entry: {}
    }
  },
  methods: {
    createEntry() {
      const entryOb = { [this.entry.eid]: this.entry }
      try {
        let eid = Object.keys(entryOb)[0]
        // console.log('EID: ' + eid)
        if (eid == undefined || eid == 'undefined' || eid == '') {
          throw 'Entry Object key is undefined '
        }
      } catch (error) {
        console.error(error + ': can not proceed')
        const notification = {
          title: 'There is a problem creating your entry',
          type: 'error',
          code: '',
          message:
            error +
            'Please reload the page and try again. If the problem persists please contact paul@picturk.com'
        }
        return this.$store.dispatch('notification/add', notification, {
          root: true
        })
        // expected output: ReferenceError: nonExistentFunction is not defined
        // Note - error messages will vary depending on browser
      }
      this.$store
        .dispatch('entry/createEntry', entryOb)
        .then(() => {
          this.$router.push({
            name: 'update-entry',
            params: { eid: this.entry.eid }
          })
          // this.entry = this.entryObject()
        })
        .catch(error => {
          const notification = {
            title: 'There is a problem creating your entry',
            type: 'error',
            code: error.code,
            message: error.message
          }
          return this.$store.dispatch('notification/add', notification, {
            root: true
          })
        })
    },
    entryObject() {
      const date = +new Date()
      const eid = Math.floor(Math.random() * 10000000)
      return {
        date: date,
        eid: eid,
        title: '',
        period: '',
        statement: '',
        photos: {},
        complete: false
      }
    }
  },
  created() {
    this.entry = this.entryObject()
  }
}
</script>

<style scoped>
.add-entry {
  cursor: pointer;
}
</style>
